var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9137 29.7756L32.8075 29.8306L29.37 43.3194L32.8075 45.0656C32.8075 45.0656 32.6425 42.0269 34.1687 39.1119C35.695 36.1969 38.7269 33.3575 44.0412 33.44C54.4087 33.5981 54.8212 45.2169 54.8212 45.2169C54.8212 45.2169 61.6894 40.6794 60.6856 39.4075C59.675 38.1356 53.9137 29.7756 53.9137 29.7756Z",
    fill: "#F17900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2343 41.9443C24.2343 41.9443 23.3268 48.4893 26.9293 54.5875C29.5762 59.0631 34.5468 63.7312 43.4843 63.8962C51.8443 64.0543 57.8462 59.6681 60.6237 54.6356C63.8618 48.7643 63.2706 42.3087 63.2706 42.3087C63.2706 42.3087 55.9762 51.15 55.4468 51.7825C54.9174 52.415 44.3368 57.8118 44.3368 57.8118C44.3368 57.8118 35.5574 57.5506 34.9181 55.9625C34.2856 54.3743 24.2343 41.9443 24.2343 41.9443Z",
    fill: "#F17900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0344 24.3788C29.2256 24.3031 23.9731 36.3 24.1244 43.5325C24.2963 51.7 29.6519 61.9163 43.615 61.9163C57.4888 61.9163 63.1881 50.9369 63.36 42.68C63.4563 37.7438 59.7781 24.4681 44.0344 24.3788ZM54.7594 44.8044C54.4156 51.4456 48.9706 55.1032 43.5256 55.1032C38.1631 55.1032 32.89 50.8475 32.8006 43.8694C32.7044 36.1213 37.4825 31.6732 44.0344 31.8725C52.4631 32.1269 55.0756 38.6856 54.7594 44.8044Z",
    fill: "#FFA624"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8957 14.2381C39.8957 14.2381 39.0569 19.7931 44.1375 19.8481C49.0944 19.8962 48.565 14.96 48.565 14.96L45.9869 9.69373L39.8957 14.2381Z",
    fill: "#F17900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0338 14.4994C75.0338 14.4994 77.2957 17.4831 74.1057 20.7488C71.892 23.0106 67.8082 26.7781 66.8801 27.61C65.4157 28.9163 62.8101 29.0331 60.9951 27.4244C58.5957 25.3 60.232 22.1444 60.232 22.1444L75.0338 14.4994Z",
    fill: "#F17900"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4063 43.4432C68.3101 44.9969 68.5851 48.2557 71.7682 48.4688C74.8826 48.6819 81.7026 48.7782 83.0501 48.6269C84.3976 48.4757 85.8551 47.0663 86.0132 45.0382C86.1576 43.12 85.2707 41.5594 85.0645 41.5044C84.8582 41.4494 68.4063 43.4432 68.4063 43.4432Z",
    fill: "#F17900"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2974 61.5175C61.2974 61.5175 59.3105 62.8237 59.3449 65.175C59.3793 67.1962 61.0018 68.5437 64.0681 71.555C67.1343 74.5731 68.4887 75.5562 70.6199 75.6662C72.8062 75.7762 74.4149 73.9818 74.6212 72.3937C74.9168 70.0837 74.0368 69.2175 74.0368 69.2175L61.2974 61.5175Z",
    fill: "#F17900"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4763 81.2282C39.4763 81.2282 38.9606 86.1369 43.4294 86.2125C48.1594 86.2882 47.795 81.18 47.795 81.18L43.1681 79.0969L39.4763 81.2282Z",
    fill: "#F17900"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3475 71.5481C12.3475 71.5481 12.1756 73.3218 13.7363 74.7243C14.8294 75.7075 16.7131 76.175 18.6863 75.1918C20.8794 74.0918 23.4094 71.0187 24.7569 69.5612C26.1113 68.1037 28.3388 65.6218 27.2525 63.2293C26.3106 61.1531 25.2863 61.1737 25.2863 61.1737L12.3475 71.5481Z",
    fill: "#F17900"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88368 42.845C1.88368 42.845 1.18243 47.9256 4.60618 48.3175C8.24993 48.73 14.6849 48.6681 16.4449 48.5238C19.0437 48.3175 19.7793 45.7394 19.6349 42.7488C19.5249 40.4938 10.5187 42.2813 10.5187 42.2813L1.88368 42.845Z",
    fill: "#F17900"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9668 12.9731C14.9668 12.9731 11.0412 15.0081 13.1312 18.8375C14.8568 22 20.2331 27.2181 21.7731 28.0775C23.9112 29.2669 26.1181 28.4144 27.1356 27.2319C28.7443 25.3619 27.8781 22.8594 27.8781 22.8594L14.9668 12.9731Z",
    fill: "#F17900"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2613 1.20312C41.9856 1.20312 40.1019 2.76375 39.9438 4.895C39.7856 7.02625 39.8338 13.64 39.8681 14.6369C39.9025 15.6338 41.2775 17.4419 44.0756 17.5106C47.5475 17.5931 48.6063 15.2831 48.6063 15.2831C48.6063 15.2831 48.5238 6.40063 48.5238 5.10125C48.5238 3.80188 47.7469 1.20312 44.2613 1.20312Z",
    fill: "url(#paint0_radial_12447_46313)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2688 14.4582C66.7288 15.7575 61.6413 19.965 60.4176 21.7663C59.6544 22.8869 59.4551 24.7913 61.0844 26.0838C62.2532 27.0188 64.9826 27.1357 66.6394 25.7744C68.2963 24.4132 73.0401 19.9513 74.3326 18.37C75.3638 17.1119 76.2369 15.3657 74.2913 13.64C72.3526 11.9144 69.9532 13.035 68.2688 14.4582Z",
    fill: "url(#paint1_radial_12447_46313)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8507 40.0263C70.125 40.1982 68.3994 41.5388 68.3994 43.4775C68.3994 45.4163 69.6919 46.5713 72.5657 46.7157C75.4394 46.86 80.9738 46.7844 82.6994 46.7157C84.4938 46.6469 85.7107 44.9969 85.6488 43.0513C85.58 40.7482 83.4213 40.1019 81.5513 40.0332C79.6813 39.9507 73.2875 39.8819 71.8507 40.0263Z",
    fill: "url(#paint2_radial_12447_46313)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2288 61.5519C60.06 62.6037 59.1663 64.6937 62.0332 67.4575C64.9069 70.2212 67.2444 72.7031 69.6782 73.7C71.2594 74.3462 72.38 74.2431 73.7344 72.8406C74.635 71.9056 74.8344 70.2419 73.9132 68.9975C72.0844 66.5225 67.375 62.2394 65.4432 61.2081C63.7519 60.3144 62.3357 60.5481 61.2288 61.5519Z",
    fill: "url(#paint3_radial_12447_46313)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6493 68.75C41.3462 68.75 39.5106 70.5031 39.4349 73.2394C39.3593 75.9756 39.4006 80.1763 39.4349 81.2763C39.4693 82.3763 41.3599 84.0331 43.5049 84.0606C46.5712 84.1019 47.8018 82.0944 47.7949 81.18C47.7881 80.3069 47.7674 74.4219 47.7881 73.3288C47.8293 71.1219 46.3031 68.75 43.6493 68.75Z",
    fill: "url(#paint4_radial_12447_46313)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8844 61.4212C24.4612 60.3831 22.1787 60.1769 19.7794 62.425C17.38 64.6731 14.0594 67.9937 13.3237 69.0319C12.5812 70.07 11.7769 72.0294 12.9112 73.2944C14.0937 74.6281 16.8506 74.4081 18.6587 72.8406C20.4669 71.2731 25.2312 66.22 26.3656 64.5287C27.3075 63.1056 27.1287 62.3287 25.8844 61.4212Z",
    fill: "url(#paint5_radial_12447_46313)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77496 39.7513C3.83621 39.8063 1.82871 40.9888 1.80121 43.3263C1.77371 45.6638 3.58871 46.5576 5.47934 46.6607C7.36996 46.7638 14.5818 46.9288 16.3693 46.7844C18.1568 46.6332 19.4356 45.3682 19.635 43.3332C19.8343 41.2982 18.095 40.1569 16.2593 39.9576C14.4237 39.7513 7.56246 39.7032 5.77496 39.7513Z",
    fill: "url(#paint6_radial_12447_46313)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7675 13.1244C13.5231 14.2313 13.0625 16.2525 14.8019 18.535C17.05 21.4913 20.735 24.9288 22.0413 25.9394C23.5813 27.1288 25.7675 27.1357 27.1356 25.4925C28.2356 24.1725 28.38 22.8113 26.4894 20.4738C24.5988 18.1363 20.6731 14.1625 19.6831 13.2688C18.4044 12.1138 16.1081 11.9282 14.7675 13.1244Z",
    fill: "url(#paint7_radial_12447_46313)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12447_46313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.7918 -0.907707) scale(19.1855 19.1855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#FFA624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8158,
    stopColor: "#FF8C0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_12447_46313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.8529 12.0738) scale(16.489 16.489)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#FFA624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8158,
    stopColor: "#FF8C0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12447_46313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.0686 43.5468) scale(14.5228 14.5228)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3162,
    stopColor: "#FFA624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8158,
    stopColor: "#FF8C0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_12447_46313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.4415 72.2322) scale(12.8497 12.8497)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#FFA624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8158,
    stopColor: "#FF8C0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_12447_46313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.5703 82.4125) scale(12.0246 12.0246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#FFA624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8158,
    stopColor: "#FF8C0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_12447_46313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7006 72.5545) scale(14.2453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#FFA624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8158,
    stopColor: "#FF8C0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_12447_46313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.50449 43.4066) scale(17.3346 17.3346)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#FFA624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8158,
    stopColor: "#FF8C0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_12447_46313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5059 14.6933) scale(14.2726 14.2726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#FFA624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8158,
    stopColor: "#FF8C0C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunIcon);
export default __webpack_public_path__ + "static/media/sun-icon.d3890feb465075d9f104fc3e8aff69a4.svg";
export { ForwardRef as ReactComponent };